import {useCallback} from "react";
import {useDispatch} from "react-redux";

import {
  resetPrevDataCasinoTournamentNextInstance,
  resetPrevDataGameBoxRaffle,
  setGameBoxTag,
} from "../store/actionCreators/gameBoxMission";

export const useSetGameBoxType = () => {
  const dispatch = useDispatch();

  const resetPrevData = () => {
    dispatch(resetPrevDataGameBoxRaffle());
    dispatch(resetPrevDataCasinoTournamentNextInstance());
  };

  return useCallback((type: any) => {
    dispatch(setGameBoxTag(type));
    resetPrevData();
  }, []);
};
